import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import "./styles.css";
// Harakat va joylashuv — ikkala mavzu uchun bitta (izoh faylning o'zida)
import "./motion.css";
// Kunduzgi mavzu — faqat rang, eng oxirida
import "./theme-light.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root topilmadi");

/*
 * Render daraxtidan TASHQARIDAGI xatolar. Error boundary ularni
 * ushlay olmaydi (u faqat render paytida ishlaydi), lekin Telegram
 * ichida DevTools yo'q — shuning uchun hech bo'lmasa konsolga aniq
 * belgi bilan yozamiz.
 */
window.addEventListener("unhandledrejection", (event) => {
  console.error("Ushlanmagan promise xatosi:", event.reason);
});
window.addEventListener("error", (event) => {
  console.error("Global xato:", event.error ?? event.message);
});

createRoot(container).render(
  <StrictMode>
    {/* Ildizdagi to'siq: App'ning o'zi (yuklanish, pastki panel)
        yiqilsa ham bo'sh ekran o'rniga tushunarli xabar chiqadi. */}
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
